/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */
import { useState } from 'react';
import { useEffect } from 'react';
import ServicesGrid from './Grid';
import ServicesCreate from './Create';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import SideDrawer from '../../../../Components/SideDrawer';
import ContentWrapper from '../../../../Layouts/AdminLTE/ContentWrapper';
import { LoadResourceAction } from '../../../../Redux/Actions/CrudActions';
import Badge from '../../../../Components/Badge';

export default function UtilitiesIndex() {

    const { utility_id } = useParams(); 
    
    const ACTION_TYPE = "COMMON";

    const PAGENAME = 'Utility Services';

    const [pageName, setPageName] = useState(PAGENAME);
    
    const CREATE_BUTTON_NAME = 'Create a Utility Service';

    const LIST_BACKEND_ROUTE = `services_by_utility/${utility_id}`

    const [tablecolumn, setTablecolumn] = useState({
        columns: [
            { title: 'Service Id', field: 'id' },
            { title: 'Service Name', field: 'name' },
            { title: 'Level', field: 'level', render: rowData => <Badge bgColor={rowData.level.color_code} data={rowData.level.name} /> },
            { title: 'Service Status', render: rowData => <div> {
                rowData.status === 1 ? 
                <span className="badge badge-pill badge-success">Active</span> 
                : <span className="badge badge-pill badge-danger">Inactive</span>
            }
            </div> },
            { title: 'Utility', field: 'utility.name' },
            { title: 'Department', field: 'department.name' },
            { title: 'Created At', field: 'created_at' },
            { title: 'Updated At', field: 'updated_at' },
        ]
    });

    const dispatch = useDispatch();

    const [data, setData] = useState([]);

    const state = useSelector(state => state.common);

    const [DrawerCreateStatus, setDrawerCreateStatus] = useState(false);

    useEffect(() => {
        dispatch({ type: `RESTART_${ACTION_TYPE}_LIST` });
        dispatch(LoadResourceAction(LIST_BACKEND_ROUTE, ACTION_TYPE));
    }, []);

    useEffect(() => {
        if (state.all.success && state.all.list) {
            setData(state.all.list ? state.all.list : []);
            setPageName(state.all.extra ? `${state.all.extra.utility.name} ${PAGENAME}` : "");
            dispatch({ type: `RESTART_${ACTION_TYPE}_LIST` });
        }
    }, [state]);

    const HandleDrawerCreate = () => {
        if (DrawerCreateStatus === false) {
            setDrawerCreateStatus(true);
        } else if (DrawerCreateStatus === true) {
            setDrawerCreateStatus(false);
        }
    }
    
    return (
        <ContentWrapper pageName={pageName} breadcrumbs={breadcrumbs(pageName,`/utilities`,"Utilities")}>
            <div className="card rounded">
                <div className="card-body p-0">
                    <SideDrawer 
                        status={DrawerCreateStatus} 
                        action_heading={CREATE_BUTTON_NAME} 
                        handle={HandleDrawerCreate}>
                        {DrawerCreateStatus && <ServicesCreate />}
                    </SideDrawer>
                    <ServicesGrid
                        dataList={data}
                        Title={pageName}
                        setDataList={setData}
                        columns={tablecolumn}
                        HandleDrawerCreate={HandleDrawerCreate}
                    />
                </div>
            </div>
        </ContentWrapper>

    );
};
function breadcrumbs(PageName, IndexRoute = false, IndexPageName = false) {
    return (
        <>
            {IndexPageName && <li className="breadcrumb-item">
                <NavLink to={IndexRoute}>{IndexPageName}</NavLink></li>}
            <li className="breadcrumb-item active">{PageName}</li>
        </>
    )
}
